export default function JobCard({ hit, onSelect }) {
  const salary =
    hit.salary_min && hit.salary_max
      ? `${hit.salary_min.toLocaleString("fr-FR")}€ - ${hit.salary_max.toLocaleString("fr-FR")}€`
      : null;

  return (
    <div
      onClick={() => onSelect(hit)}
      className="bg-gray-800 rounded-2xl border border-gray-700 hover:border-gray-600 transition cursor-pointer overflow-hidden flex flex-col"
    >
      {hit.photo_url && (
        <div className="h-40 overflow-hidden shrink-0">
          <img
            src={hit.photo_url}
            alt={hit.title}
            className="w-full h-full object-cover object-top"
            loading="lazy"
          />
        </div>
      )}
      <div className="p-4 flex flex-col gap-2 flex-1">
        {/* Titre + salaire */}
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-semibold text-white text-sm leading-tight">{hit.title}</h3>
          {salary && (
            <span className="text-xs font-medium text-teal-400 shrink-0 whitespace-nowrap">
              {salary}
            </span>
          )}
        </div>

        {/* Description */}
        {hit.description && (
          <p className="text-xs text-gray-400 line-clamp-2">{hit.description}</p>
        )}

        {/* Qualités */}
        {hit.qualities_label?.length > 0 && (
          <div className="flex flex-wrap gap-1 mt-auto pt-1">
            {hit.qualities_label.slice(0, 3).map((q) => (
              <span key={q} className="text-[10px] text-blue-300 bg-blue-500/10 px-2 py-0.5 rounded-full">
                {q}
              </span>
            ))}
          </div>
        )}

        {/* Niveaux d'études — ligne séparée */}
        {hit.study_levels_label?.length > 0 && (
          <div className="flex flex-wrap gap-1">
            {hit.study_levels_label.map((s) => (
              <span key={s} className="text-[10px] text-orange-300 bg-orange-500/10 px-2 py-0.5 rounded-full">
                {s}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
